var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalorieDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8236 24.9056C4.87104 24.9056 0.841797 20.5895 0.841797 15.2844C0.841797 11.1584 2.59652 7.47944 5.17285 4.458C7.2918 1.97296 9.38892 0.604555 9.47713 0.547562C9.94198 0.247071 10.5659 0.656484 10.5659 1.21017V7.80114L13.7215 4.65392C13.9954 4.3807 14.429 4.39962 14.6801 4.70303C15.8795 6.15174 16.8342 7.68156 17.5177 9.25009C21.33 17.9984 16.0747 24.9056 9.8236 24.9056Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.515 9.24985C16.8304 7.68129 15.8742 6.15143 14.6729 4.70269C14.4214 4.39923 13.9871 4.38036 13.7127 4.65357L10.5521 7.80087V1.20975C10.5521 0.79287 10.1979 0.457927 9.82422 0.445984V24.9056C16.0785 24.8942 21.3302 17.9911 17.515 9.24985Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8245 24.9056C7.70164 24.9056 5.97461 23.1768 5.97461 21.052C5.97461 17.6184 9.3131 15.5853 9.45519 15.5004C9.70429 15.3517 10.0162 15.3587 10.2584 15.518C10.3979 15.6099 13.6743 17.8043 13.6743 21.052C13.6744 23.1768 11.9474 24.9056 9.8245 24.9056Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalorieDisable);
export default __webpack_public_path__ + "static/media/calorie_Disable.2d4ed057505ec90c32052c7d320e36b7.svg";
export { ForwardRef as ReactComponent };